export { default as translations } from './translations.json';

export const CO_HOST_ROLES = ['viewer', 'responder', 'manager'];

/**
 * Get co-hosts from listing.
 * @param {Object|null} listing
 * @returns {Object[]}
 */
export const getCoHosts = (listing) =>
  listing?.attributes?.publicData?.coHosts || [];

/**
 * Check if a user is a co-host.
 * @param {Object|null} listing
 * @param {string} userId
 * @returns {boolean}
 */
export const isCoHost = (listing, userId) =>
  getCoHosts(listing).some(h => h.userId === userId);

/**
 * Get co-host role.
 * @param {Object|null} listing
 * @param {string} userId
 * @returns {string|null}
 */
export const getCoHostRole = (listing, userId) =>
  getCoHosts(listing).find(h => h.userId === userId)?.role || null;

/**
 * Check if co-host can perform action based on role hierarchy.
 * viewer < responder < manager
 */
const ROLE_LEVEL = { viewer: 1, responder: 2, manager: 3 };
export const canCoHostPerform = (listing, userId, minRole) =>
  (ROLE_LEVEL[getCoHostRole(listing, userId)] || 0) >= (ROLE_LEVEL[minRole] || 0);
